"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAI = function FlagAI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.89-38.49c-1,12.62-4.87,92.84,46,111,50.92-18.14,47-98.35,46-111-6.17,2.42-28.49,9.74-46-2.74-17.53,12.48-39.85,5.16-46,2.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M140.92-22.3c-2.79-2.18-8,1.85-13.74,1.44-5.37-.38-12-5.82-20.58-3.48-2.38-2.18-1.22-7.27-1.22-7.27-6,3.86-6.4,9.15-6,12C95.1-14,95.38-5.39,96.18-2.77c1,3.41,3,3.82,3.3,7.64s1.76,2.48,1.76,2.48c3-1.67,3.42-4.84,4.68-10,4.86.62,8-3.73,8-3.73a5.33,5.33,0,0,1-6.29-2.31c.17-.51.31-1,.5-1.51,3.62-9.93,20.93-7.2,22.53-4.45a17.87,17.87,0,0,0,6.72,6.82c0-5.17-3.82-9.71-3.82-9.71,5.78-1,7.33-4.75,7.33-4.75ZM99.28-1a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa028"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.88,41.17c3.37-1.06,3-7.61,6.61-12.13,3.36-4.21,11.59-6.57,14.54-15,3.15-.72,6.68,3.12,6.68,3.12.21-7.11-3.9-10.46-6.47-11.77C143-1.29,135.79-5.92,133.18-6.75c-3.39-1.09-4.84.29-8.17-1.62s-3,0-3,0c-.31,3.41,2,5.56,5.59,9.53-3.26,3.65-1.48,8.73-1.48,8.73a5.34,5.34,0,0,1,5.46-3.87c.33.43.64.81,1,1.28,6.12,8.6-5.95,21.31-9.12,21.07A17.85,17.85,0,0,0,114,30.07c4.26,2.93,10.17,2.36,10.17,2.36-2.43,5.36-.25,8.74-.25,8.74ZM130-5.2a1,1,0,0,1,1.43-.26A1,1,0,0,1,131.68-4a1,1,0,0,1-1.44.27A1,1,0,0,1,130-5.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa028"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M78.32-4.76c-.45,3.51,5.65,5.9,8.23,11.1C89,11.16,87.63,19.62,94,25.83c-.68,3.16-5.64,4.75-5.64,4.75,6.36,3.18,11.12.87,13.4-.92,7,.81,14.25-3.8,16.11-5.81,2.41-2.62,1.77-4.53,4.9-6.74S124,14.34,124,14.34c-3-1.72-5.91-.49-11,1.06-1.93-4.5-7.29-5-7.29-5A5.32,5.32,0,0,1,107,17c-.53.12-1,.24-1.56.34C95,19.23,88.56,2.94,90.11.16a17.83,17.83,0,0,0,2.46-9.25C88.11-6.46,86.14-.86,86.14-.86c-3.82-4.46-7.82-3.9-7.82-3.9Zm39.5,25a1,1,0,1,1-1.41-.37,1,1,0,0,1,1.41.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa028"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M115.91,75.11l-.4-.14C58.2,55,67.46-39.46,67.56-40.42l.18-1.7,1.56.71c.28.12,26.86,11.91,45.87-2.35l.74-.56.75.56c19,14.28,45.6,2.47,45.86,2.35l1.57-.71.18,1.7c.1,1,9.36,95.45-48,115.39Zm-46-113.6c-1,12.62-4.87,92.84,46,111,50.92-18.14,47-98.35,46-111-6.17,2.42-28.49,9.74-46-2.74-17.53,12.48-39.85,5.16-46,2.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#cdce0c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M84,44c7,12.6,17.1,23.16,31.91,28.44,14.83-5.28,25-15.84,31.93-28.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAI;
exports["default"] = _default;